import { withCompInfo } from '@wix/editor-elements-integrations'
import { MenuToggleCSS, MenuToggleDefinition } from './MenuToggle'

export const css = withCompInfo<MenuToggleCSS, MenuToggleDefinition>()(
	['compLayout', 'isMobileView'],
	({ compLayout, isMobileView }) => {
		return compLayout.fixedPosition && isMobileView
			? {
					'margin-top': 'var(--wix-ads-height)',
					position: 'fixed !important',
					top: `${compLayout.y}px`,
					left: `${compLayout.x}px`,
			  }
			: {}
	}
)
